/** An `aria-labelledby` reference beats a literal `aria-label`; passing both would let the label silently shadow the visible title. */
export function dialogNameAttrs(
  labelledBy: string | undefined,
  label: string | undefined,
): { 'aria-labelledby'?: string; 'aria-label'?: string } {
  if (labelledBy) return { 'aria-labelledby': labelledBy }
  if (label) return { 'aria-label': label }
  return {}
}
